/* Tool box pages: filters on the left (snippets/tcmn-tb-browse.liquid).
   Loads the whole collection from ?view=tbdata (templates/collection.tbdata.liquid), then filters,
   counts, sorts and pages it in the browser. Cards copy snippets/product-card.liquid.
   Filters come from product tags "Truck Size: ", "Length: ", "Material: ", "Finish: ", "Style: ",
   plus brand (vendor), price and box type (the tool box type collections).
   With a saved truck (lakewood:selected-vehicle:v1) "Fits my truck" hides boxes sized for the other
   truck class and stands in for the Truck size group; the shopper can switch it off for the visit.
   Options with no matching boxes are hidden.
   Choices are kept in the address bar so a filtered page can be shared or reloaded. */
(function () {
  'use strict';

  var root = document.querySelector('[data-tb-browse]');
  if (!root) return;

  var STEP = 24;
  var VKEY = 'lakewood:selected-vehicle:v1';
  var FIT_OFF = 'tcmn:tb-fit-off';
  var PRICES = [
    { id: 'under-250', lo: 0, hi: 25000, label: 'Under $250' },
    { id: '250-500', lo: 25000, hi: 50000, label: '$250 to $500' },
    { id: '500-1000', lo: 50000, hi: 100000, label: '$500 to $1,000' },
    { id: '1000-2000', lo: 100000, hi: 200000, label: '$1,000 to $2,000' },
    { id: '2000-up', lo: 200000, hi: Infinity, label: '$2,000 and up' }
  ];
  var GROUPS = [
    { key: 'box', label: 'Box type' },
    { key: 'size', label: 'Truck size', tag: 'Truck Size: ' },
    { key: 'length', label: 'Length', tag: 'Length: ' },
    { key: 'material', label: 'Material', tag: 'Material: ' },
    { key: 'brand', label: 'Brand' },
    { key: 'finish', label: 'Finish / color', tag: 'Finish: ' },
    { key: 'style', label: 'Style & features', tag: 'Style: ' },
    { key: 'price', label: 'Price' }
  ];
  var SIZE_LABEL = { 'Full-Size': 'Full-size trucks', 'Mid-Size': 'Mid-size trucks' };
  var SORTS = ['price-ascending', 'price-descending', 'created-descending', 'title-ascending'];

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var grid = $('[data-tb-grid]');
  var groupsEl = $('[data-tb-groups]');
  var fitEl = $('[data-tb-fit]');
  var activeEl = $('[data-tb-active]');
  var panel = $('#TbFilters');
  var openBtn = $('[data-tb-open]');
  var sortEl = $('[data-tb-sort]');
  var html = document.documentElement;

  /* box type names and order come from the type row at the top of the page */
  var boxNames = {}, boxOrder = [], onTypePage = false;
  $$('[data-tb-type]', document).forEach(function (a) {
    var h = a.getAttribute('data-tb-type');
    if (a.hasAttribute('data-tb-all')) return;
    var n = a.querySelector('.tb-type__name');
    boxNames[h] = n ? n.textContent.trim() : h;
    boxOrder.push(h);
    if (a.classList.contains('is-active')) onTypePage = true;
  });

  var all = [], ready = false, shown = STEP, sort = '', sel = {}, opts = {}, groupEls = {};
  var fitOn = true, fitClass = null, fitVehicle = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function moneyShort(c) { return c % 100 ? money(c) : '$' + (c / 100).toLocaleString('en-US'); }
  function ss(k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }

  /* ---------- saved truck ---------- */
  function readVehicle() {
    try {
      var v = JSON.parse(window.localStorage.getItem(VKEY) || 'null');
      return v && v.year && v.make && v.model ? v : null;
    } catch (e) { return null; }
  }
  function classOf(v) {
    if (!v) return null;
    var mk = String(v.make).toLowerCase(), md = String(v.model).toLowerCase();
    if (/transit|express|savana|sprinter|promaster|metris|econoline|van\b/.test(md)) return null;
    if (/ranger|colorado|canyon|tacoma|frontier|gladiator|ridgeline|maverick|santa cruz|dakota/.test(md)) return 'Mid-Size';
    if (/^f-?\d{3}|super duty|silverado|sierra|tundra|titan/.test(md)) return 'Full-Size';
    if ((mk === 'ram' || mk === 'dodge') && /(^|\s)(ram\s)?[123]500\b/.test(md)) return 'Full-Size';
    return null;
  }
  function vehicleLabel(v) { return [v.year, v.make, v.model].filter(Boolean).join(' '); }
  function setVehicle() {
    fitVehicle = readVehicle();
    fitClass = classOf(fitVehicle);
    fitOn = ss(FIT_OFF) !== '1' && !(sel.size && sel.size.length);
  }

  /* ---------- address bar ---------- */
  function readUrl() {
    var q = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) {
      var v = q.getAll(g.key).filter(Boolean);
      if (v.length) sel[g.key] = v;
    });
    if (q.get('fit') === 'off' || sel.size) fitOn = false;
    var s = q.get('sort_by') || '';
    sort = SORTS.indexOf(s) > -1 ? s : '';
    if (sortEl) sortEl.value = sort;
  }
  function writeUrl() {
    var q = new URLSearchParams(window.location.search);
    GROUPS.forEach(function (g) { q.delete(g.key); });
    q.delete('page');
    q.delete('sort_by');
    q.delete('fit');
    GROUPS.forEach(function (g) { (sel[g.key] || []).forEach(function (v) { q.append(g.key, v); }); });
    if (sort) q.set('sort_by', sort);
    var s = q.toString();
    try { window.history.replaceState(null, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash); } catch (e) {}
  }

  /* ---------- data ---------- */
  function prep(p) {
    var vals = { box: p.k || [], brand: p.v ? [p.v] : [], price: [] };
    GROUPS.forEach(function (g) {
      if (!g.tag) return;
      vals[g.key] = (p.f || []).filter(function (t) { return t.indexOf(g.tag) === 0; })
        .map(function (t) { return t.slice(g.tag.length); });
    });
    for (var i = 0; i < PRICES.length; i++) {
      if (p.p >= PRICES[i].lo && p.p < PRICES[i].hi) { vals.price = [PRICES[i].id]; break; }
    }
    p.vals = vals;
    return p;
  }
  function parse(text) {
    var a = text.indexOf('{'), b = text.lastIndexOf('}');
    return JSON.parse(text.slice(a, b + 1));
  }
  function getPage(n) {
    var url = root.getAttribute('data-tb-data');
    var pv = new URLSearchParams(window.location.search).get('preview_theme_id');
    url += '&page=' + n + (pv ? '&preview_theme_id=' + encodeURIComponent(pv) : '');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('tbdata ' + r.status);
      return r.text();
    }).then(parse);
  }
  function load() {
    var guess = Math.max(1, Math.ceil((parseInt(root.getAttribute('data-tb-total'), 10) || 0) / 250));
    var jobs = [];
    for (var n = 1; n <= guess; n++) jobs.push(getPage(n));
    return Promise.all(jobs).then(function (pages) {
      var extra = [];
      for (var m = guess + 1; m <= (pages[0].pages || 1); m++) extra.push(getPage(m));
      return Promise.all(extra).then(function (more) {
        var items = [];
        pages.concat(more).forEach(function (d) { items = items.concat(d.items || []); });
        return items;
      });
    });
  }

  /* ---------- filtering ---------- */
  function matches(p, skip) {
    for (var i = 0; i < GROUPS.length; i++) {
      var k = GROUPS[i].key;
      if (k === skip) continue;
      var s = sel[k];
      if (!s || !s.length) continue;
      var pv = p.vals[k], hit = false;
      for (var j = 0; j < pv.length; j++) if (s.indexOf(pv[j]) > -1) { hit = true; break; }
      if (!hit) return false;
    }
    if (fitOn && fitClass && p.vals.size.length && p.vals.size.indexOf(fitClass) < 0) return false;
    return true;
  }
  function sorted(list) {
    var by = {
      'price-ascending': function (a, b) { return a.p - b.p; },
      'price-descending': function (a, b) { return b.p - a.p; },
      'created-descending': function (a, b) { return b.d - a.d; },
      'title-ascending': function (a, b) { return a.t.localeCompare(b.t); }
    }[sort];
    if (!by) return list;
    return list.map(function (p, i) { return { p: p, i: i }; })
      .sort(function (x, y) { return by(x.p, y.p) || x.i - y.i; })
      .map(function (x) { return x.p; });
  }
  function label(k, v) {
    if (k === 'size') return SIZE_LABEL[v] || v;
    if (k === 'box') return boxNames[v] || v;
    if (k === 'price') {
      for (var i = 0; i < PRICES.length; i++) if (PRICES[i].id === v) return PRICES[i].label;
    }
    return v;
  }
  function valueOrder(k, values) {
    if (k === 'length') return values.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
    if (k === 'price') return PRICES.map(function (x) { return x.id; }).filter(function (id) { return values.indexOf(id) > -1; });
    if (k === 'box') return boxOrder.filter(function (h) { return values.indexOf(h) > -1; });
    if (k === 'size') return values.sort();
    return values.sort(function (a, b) { return a.localeCompare(b); });
  }

  /* ---------- cards (same markup as snippets/product-card.liquid) ---------- */
  function srcw(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function img(u, alt, r, cls) {
    var ws = [300, 420, 600, 760, 900, 1000];
    return '<img src="' + esc(srcw(u, 1000)) + '" alt="' + esc(alt) + '" srcset="' +
      ws.map(function (w) { return esc(srcw(u, w)) + ' ' + w + 'w'; }).join(', ') +
      '" width="1000" height="' + Math.round(1000 / (r || 1)) + '" loading="lazy" sizes="(min-width: 1280px) 23vw, (min-width: 760px) 31vw, 50vw" class="' + cls + '">';
  }
  function card(p) {
    var g = p.g || '', save = p.c > p.p ? p.c - p.p : 0, badges = '', media;
    if (save > 0) badges += '<span class="lw-product-card__badge is-sale">Save ' + moneyShort(save) + '</span>';
    else if (g.indexOf('b') > -1) badges += '<span class="lw-product-card__badge is-best">Best seller</span>';
    else if (g.indexOf('n') > -1) badges += '<span class="lw-product-card__badge is-new">New</span>';
    if (g.indexOf('f') > -1) badges += '<span class="lw-product-card__badge">Vehicle specific</span>';
    if (!p.a) badges += '<span class="lw-product-card__badge is-muted">Sold out</span>';
    if (p.i) {
      media = img(p.i, p.ia, p.r, 'lw-product-card__image lw-product-card__image--primary');
      if (p.i2) media += img(p.i2, p.i2a, p.r, 'lw-product-card__image lw-product-card__image--secondary');
    } else {
      media = '<div class="lw-product-card__placeholder"></div>';
    }
    return '<article class="lw-product-card lw-product-card--next"><a class="lw-product-card__link" href="' + esc(p.u) + '">' +
      '<div class="lw-product-image' + (p.i && p.i2 ? ' has-secondary' : '') + '"><div class="lw-product-card__badges">' + badges + '</div>' + media + '</div>' +
      '<div class="lw-product-info"><div class="lw-product-card__topline">' +
      (g.indexOf('h') < 0 && p.v ? '<span class="lw-product-brand">' + esc(p.v) + '</span>' : '') +
      (p.s ? '<span class="lw-product-card__sku">#' + esc(p.s) + '</span>' : '') + '</div>' +
      '<h3 class="lw-product-title">' + esc(p.t) + '</h3>' +
      (p.y ? '<div class="lw-product-card__type">' + esc(p.y) + '</div>' : '') +
      '<div class="lw-product-card__meta">' + (p.pv ? '<span>From</span> ' : '') + '<strong class="lw-product-price">' + money(p.p) + '</strong>' +
      (p.c > p.p ? ' <s>' + money(p.c) + '</s>' : '') + '</div>' +
      '<div class="lw-product-card__fulfillment">' + (p.fs || '') +
      (g.indexOf('u') > -1 ? '<span>Made in USA</span>' : (p.a ? '<span>Available to order</span>' : '')) + '</div>' +
      '<div class="lw-product-actions"><span class="lw-btn">' + (g.indexOf('f') > -1 ? 'Check fitment &amp; options' : 'View product') +
      ' <span aria-hidden="true">&rarr;</span></span></div></div></a></article>';
  }

  /* ---------- filter column ---------- */
  function buildPanel() {
    var out = '';
    GROUPS.forEach(function (g) {
      var seen = {};
      all.forEach(function (p) { p.vals[g.key].forEach(function (v) { seen[v] = 1; }); });
      (sel[g.key] || []).forEach(function (v) { seen[v] = 1; });
      var values = valueOrder(g.key, Object.keys(seen));
      var show = values.length > 1 || (sel[g.key] || []).length > 0;
      if (g.key === 'box' && onTypePage && !(sel.box || []).length) show = false;
      if (!show) return;
      var open = g.key !== 'style' && g.key !== 'finish' && g.key !== 'price';
      out += '<details class="lw-filter-group tb-group" data-tb-group="' + g.key + '"' + (open ? ' open' : '') + '>' +
        '<summary><b class="tb-sum">' + esc(g.label) + '<i data-tb-n></i></b><span aria-hidden="true">+</span></summary>' +
        '<div class="lw-filter-group__body">' +
        values.map(function (v) {
          return '<label class="lw-filter-option"><input type="checkbox" data-tb-g="' + g.key + '" value="' + esc(v) + '">' +
            '<span>' + esc(label(g.key, v)) + '</span><small></small></label>';
        }).join('') + '</div></details>';
    });
    groupsEl.innerHTML = out || '<p class="tb-groups__loading">No filters for this page.</p>';
    opts = {};
    groupEls = {};
    $$('[data-tb-group]', groupsEl).forEach(function (d) { groupEls[d.getAttribute('data-tb-group')] = d; });
    $$('input[data-tb-g]', groupsEl).forEach(function (inp) {
      var k = inp.getAttribute('data-tb-g');
      (opts[k] = opts[k] || []).push(inp);
    });
  }
  function buildFit() {
    if (!fitEl) return;
    if (!fitVehicle || !fitClass) { fitEl.hidden = true; fitEl.innerHTML = ''; return; }
    var other = fitClass === 'Full-Size' ? 'mid-size' : 'full-size';
    fitEl.innerHTML = '<label class="lw-filter-option tb-fit__opt"><input type="checkbox" data-tb-fitbox' + (fitOn ? ' checked' : '') + '>' +
      '<span>Fits my <b>' + esc(vehicleLabel(fitVehicle)) + '</b></span><small></small></label>' +
      '<p>Hides boxes made for ' + other + ' trucks. <a href="/pages/shop-by-vehicle">Change truck</a></p>';
    fitEl.hidden = false;
  }
  function refreshPanel() {
    GROUPS.forEach(function (g) {
      var list = opts[g.key];
      if (!list) return;
      var counts = {}, s = sel[g.key] || [];
      all.forEach(function (p) {
        if (!matches(p, g.key)) return;
        p.vals[g.key].forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
      });
      var visible = 0;
      list.forEach(function (inp) {
        var v = inp.value, c = counts[v] || 0, on = s.indexOf(v) > -1;
        inp.checked = on;
        inp.parentNode.hidden = !c && !on;
        if (c || on) visible++;
        inp.parentNode.querySelector('small').textContent = c;
      });
      var d = groupEls[g.key];
      if (!d) return;
      d.hidden = !visible || (g.key === 'size' && fitOn && !!fitClass && !s.length);
      var n = d.querySelector('[data-tb-n]');
      if (n) n.textContent = s.length ? ' (' + s.length + ')' : '';
    });
    var fb = fitEl && fitEl.querySelector('[data-tb-fitbox]');
    if (fb) fb.checked = fitOn;
  }
  function activeCount() {
    var n = 0;
    GROUPS.forEach(function (g) { n += (sel[g.key] || []).length; });
    return n;
  }
  function refreshActive() {
    var bits = [];
    if (fitOn && fitClass && fitVehicle) {
      bits.push('<button type="button" data-tb-rm="fit">Fits ' + esc(vehicleLabel(fitVehicle)) + ' <span aria-hidden="true">&times;</span></button>');
    }
    GROUPS.forEach(function (g) {
      (sel[g.key] || []).forEach(function (v) {
        bits.push('<button type="button" data-tb-rm="' + g.key + '" data-tb-v="' + esc(v) + '">' + esc(label(g.key, v)) +
          ' <span aria-hidden="true">&times;</span></button>');
      });
    });
    var n = activeCount();
    if (n) bits.push('<button type="button" class="lw-active-filters__clear" data-tb-clear>Clear all</button>');
    activeEl.innerHTML = bits.join('');
    activeEl.hidden = !bits.length;
    $$('.tb-reset[data-tb-clear]').forEach(function (b) { b.hidden = !n; });
    var badge = $('[data-tb-badge]');
    if (badge) badge.textContent = n ? ' (' + n + ')' : '';
  }

  /* ---------- products ---------- */
  function renderProducts() {
    var list = sorted(all.filter(function (p) { return matches(p); }));
    var total = list.length;
    grid.innerHTML = list.slice(0, shown).map(card).join('');
    $('[data-tb-count]').textContent = total;
    $('[data-tb-count-label]').textContent = total === 1 ? 'product' : 'products';
    $('[data-tb-empty]').hidden = total > 0;
    var box = $('[data-tb-morebox]');
    box.hidden = total <= STEP && shown >= total;
    $('[data-tb-showing]').textContent = total ? 'Showing ' + Math.min(shown, total) + ' of ' + total : '';
    var more = $('[data-tb-more]');
    var left = total - shown;
    more.hidden = left <= 0;
    more.textContent = 'Show ' + Math.min(STEP, left) + ' more';
    var apply = $('.tb-apply');
    if (apply) apply.textContent = total === 1 ? 'Show 1 result' : 'Show ' + total + ' results';
  }
  function update(keepShown) {
    if (!keepShown) shown = STEP;
    refreshPanel();
    refreshActive();
    renderProducts();
    writeUrl();
  }
  function appendMore() {
    var list = sorted(all.filter(function (p) { return matches(p); }));
    var from = shown;
    shown += STEP;
    grid.insertAdjacentHTML('beforeend', list.slice(from, shown).map(card).join(''));
    var total = list.length, left = total - shown, more = $('[data-tb-more]');
    $('[data-tb-showing]').textContent = 'Showing ' + Math.min(shown, total) + ' of ' + total;
    more.hidden = left <= 0;
    more.textContent = 'Show ' + Math.min(STEP, left) + ' more';
  }

  /* ---------- mobile drawer ---------- */
  function setOpen(open) {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    html.classList.toggle('lw-filters-open', open);
  }

  /* ---------- events ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('input[data-tb-g]')) {
      var k = t.getAttribute('data-tb-g'), s = sel[k] || [];
      if (t.checked) { if (s.indexOf(t.value) < 0) s.push(t.value); }
      else s = s.filter(function (v) { return v !== t.value; });
      if (s.length) sel[k] = s; else delete sel[k];
      update();
    } else if (t.matches('[data-tb-fitbox]')) {
      fitOn = t.checked;
      ss(FIT_OFF, fitOn ? null : '1');
      update();
    } else if (t.matches('[data-tb-sort]')) {
      sort = SORTS.indexOf(t.value) > -1 ? t.value : '';
      if (ready) update(); else { writeUrl(); window.location.reload(); }
    }
  });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-tb-rm')) {
      var k = t.getAttribute('data-tb-rm');
      if (k === 'fit') { fitOn = false; ss(FIT_OFF, '1'); }
      else {
        var v = t.getAttribute('data-tb-v');
        sel[k] = (sel[k] || []).filter(function (x) { return x !== v; });
        if (!sel[k].length) delete sel[k];
      }
      update();
    } else if (t.hasAttribute('data-tb-clear')) {
      sel = {};
      if (fitClass) { fitOn = false; ss(FIT_OFF, '1'); }
      update();
      setOpen(false);
    } else if (t.hasAttribute('data-tb-more')) {
      appendMore();
    } else if (t.hasAttribute('data-tb-open')) {
      setOpen(true);
    } else if (t.hasAttribute('data-tb-close')) {
      setOpen(false);
      if (t.classList.contains('tb-apply')) {
        var top = root.getBoundingClientRect().top + window.pageYOffset - 70;
        if (window.pageYOffset > top) window.scrollTo(0, top);
      }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  document.addEventListener('click', function (e) {
    if (panel && panel.classList.contains('is-open') && !panel.contains(e.target) && !e.target.closest('[data-tb-open]')) setOpen(false);
  });
  document.addEventListener('lakewood:vehiclechange', function () {
    if (!ready) return;
    setVehicle();
    buildFit();
    update();
  });

  /* ---------- start ---------- */
  setVehicle();
  readUrl();
  load().then(function (items) {
    all = items.map(prep);
    ready = true;
    var pager = $('[data-tb-pager]');
    if (pager) pager.hidden = true;
    buildPanel();
    buildFit();
    update();
    root.classList.remove('is-loading');
  }).catch(function () {
    /* keep the server-rendered page and its page links */
    groupsEl.innerHTML = '<p class="tb-groups__loading">Filters could not load. <a href="' + esc(window.location.href) + '">Reload the page</a></p>';
    root.classList.remove('is-loading');
  });
})();
